// extracted by mini-css-extract-plugin
module.exports = {"container":"lesson-sidebar_container__1TFSb","sideBarClose":"lesson-sidebar_sideBarClose__1rdLF"};